import React, { useState } from 'react';
import { LeadFilters } from '../components/leads/LeadFilters';
import { LeadsTable } from '../components/leads/LeadsTable';
import { mockLeads } from '../data/mockLeads';
export function LeadsList() {
  const [leads] = useState(mockLeads);
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-732">
      <div className="flex items-center justify-between" data-id="element-733">
        <div data-id="element-734">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-735">Leads</h1>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-736">
            Gestiona y cualifica tus prospectos.
          </p>
        </div>
      </div>

      <LeadFilters data-id="element-737" />
      <LeadsTable leads={leads} data-id="element-738" />
    </div>;
}